// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./ADNOC Sans Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./ADNOC Sans Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./ADNOC Sans Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
    font-family: 'ADNOC Sans';
    src: url('./ADNOC\\ Sans\\ Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'ADNOC Sans';
    src: url('./ADNOC\\ Sans\\ Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
}


@font-face {
    font-family: 'ADNOC Sans';
    src: url('./ADNOC\\ Sans\\ Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
} */

@font-face {
    font-family: 'ADNOC Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'ADNOC Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
    font-weight: 500;
    font-style: normal;
}


@font-face {
    font-family: 'ADNOC Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
    font-weight: bold;
    font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/fonts.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;IACI,yBAAyB;IACzB,4DAAwD;IACxD,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,4DAAuD;IACvD,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,yBAAyB;IACzB,4DAAqD;IACrD,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["/* @font-face {\n    font-family: 'ADNOC Sans';\n    src: url('./ADNOC\\ Sans\\ Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'ADNOC Sans';\n    src: url('./ADNOC\\ Sans\\ Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n\n@font-face {\n    font-family: 'ADNOC Sans';\n    src: url('./ADNOC\\ Sans\\ Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n} */\n\n@font-face {\n    font-family: 'ADNOC Sans';\n    src: url('./ADNOC\\ Sans\\ Regular.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'ADNOC Sans';\n    src: url('./ADNOC\\ Sans\\ Medium.woff2') format('woff2');\n    font-weight: 500;\n    font-style: normal;\n}\n\n\n@font-face {\n    font-family: 'ADNOC Sans';\n    src: url('./ADNOC\\ Sans\\ Bold.woff2') format('woff2');\n    font-weight: bold;\n    font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
